import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import * as moment from 'moment';
import * as _ from 'lodash-es';

import { ManageCalendariService } from '../services/manage-calendar/manage-calendar.service';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface CalendarDate {
  mDate: moment.Moment;
  idTipus?: number; //per lligar amb taula tipus de dies: personal, festiu, metge, baixa, viatge....
  today?: boolean;
  observacions?: string;
}

export interface tDies {//Tipus de dies (taula calendari_tipus_dies)
  id: number;
  nom: string;
  color: string;
}

@Component({
  selector: 'app-manage-calendar',
  templateUrl: './manage-calendar.component.html',
  styleUrls: ['./manage-calendar.component.scss'],
  providers: [ ManageCalendariService ]
})

export class ManageCalendariComponent implements OnInit {
  public locale = 'ca';
  public tipusDies: tDies[] = [];
  public totalsDies: {'id': number,'valor': number}[] = [];
  public tipusIncidencia = 1;
  public observacions: string = "";
  public display = null;
  private usuari: string = '';
  public nom: string = '';
  private iniciDilluns = 1;
  private selectedDatesUsu: CalendarDate[] = [];
  private selectedDatesAdm: CalendarDate[] = [];
  //private primer = null;
  private selTxColor = 'white';
  private bkColor = 'white';
  private txColor = 'black';
  private weekEndBkColor = '#white';
  private weekEndTxColor = '#555555';
  private pos: number = null;
  private unsubscriber : Subject<void> = new Subject<void>();

  currentDate = moment();
  dayNames = [];
  weeks: CalendarDate[][] = [];
  sortedDates: CalendarDate[] = [];
  colorFons: string[] = [];
  colorText: string[] = [];

  constructor(public translate: TranslateService, public languageService: LanguageService, private manageCalendariService: ManageCalendariService, private dialog: MatDialog, public dialogRef: MatDialogRef<ManageCalendariComponent>, @Inject(MAT_DIALOG_DATA) private data){
    this.usuari = data.id;this.nom = data.nom;
  }

  ngOnInit(): void {
    this.dayNames = moment.localeData(this.locale).weekdays();
    if(this.locale == 'ca')this.dayNames = this.dayNames.slice(1,this.dayNames.length).concat(this.dayNames.slice(0,1));
    this.manageCalendariService.getTipusDies().subscribe(res => { 
      this.tipusDies = res;
      this.generateCalendar(); 
    });
    
    this.manageCalendariService.getTotalsTipusDies(this.usuari,this.currentDate.format('YYYY')).subscribe(res => {
      this.totalsDies = res;
    });
  
    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  getLegend(id): string {
    return this.languageService.label('calendariTipusRaw', this.tipusDies.find(item => item.id == id).nom) + (this.totalsDies.find(item => item.id == id)?" (" + this.totalsDies.find(item => item.id == id).valor + ")":"");
  }

  isToday(date: moment.Moment): boolean {
    return moment().isSame(moment(date), 'day');
  }

  incidenciaSelectedUsuColor(date: moment.Moment){
    if(!this.isSelectedUsu(date))return this.bkColor;
    return this.tipusDies.find(item => item.id == this.incidenciaSelectedUsu(date))?this.tipusDies.find(item => item.id == this.incidenciaSelectedUsu(date)).color:"#FFFFFF";
  }

  incidenciaSelectedAdmColor(i, j, date: moment.Moment){
    if(!this.isSelectedAdm(date))return this.colorFons[i*7+(j+1)];
    return this.tipusDies.filter(sel => sel.id == this.tipusIncidencia).map(item => this.tipusDies[this.incidenciaSelectedAdm(date)-1].color);
  }

  incidenciaSelectedAdmLabel(date: moment.Moment){
    if(!this.isSelectedAdm(date))return;
    return this.tipusDies.filter(sel => sel.id == this.tipusIncidencia).map(item => this.tipusDies[this.incidenciaSelectedAdm(date)-1].nom);
  }

  incidenciaSelectedUsuObs(date: moment.Moment){
    if(!this.isSelectedUsu(date))return;
    return this.selectedDatesUsu.find(selectedDate => {
      return moment(date).isSame(selectedDate.mDate, 'day');
    }).observacions;
  }

  incidenciaSelectedUsuLabel(date: moment.Moment){
    if(!this.isSelectedUsu(date))return;
    return this.tipusDies.filter(sel => sel.id == this.tipusIncidencia)
       .map(item => this.incidenciaSelectedUsu(date) == -1?'':this.tipusDies[this.incidenciaSelectedUsu(date)-1].nom + " - " + this.incidenciaSelectedUsuObs(date));
  }

  incidenciaSelectedAdm(date: moment.Moment): number {
    if(!this.isSelectedAdm(date))return;
    return this.selectedDatesAdm[this.selectedDatesAdm.findIndex(selectedDate => {
      return moment(date).isSame(selectedDate.mDate, 'day');
    })].idTipus;
  }

  incidenciaSelectedUsu(date: moment.Moment): number {
    if(!this.isSelectedUsu(date))return;

    return this.selectedDatesUsu[this.selectedDatesUsu.findIndex(selectedDate => {
      return moment(date).isSame(selectedDate.mDate, 'day');
    })].idTipus;
  }

  isSelectedAdm(date: moment.Moment): boolean {
    return this.selectedDatesAdm.findIndex(selectedDate => {
      return moment(date).isSame(selectedDate.mDate, 'day');
    }) > -1;
  }

  isSelectedUsu(date: moment.Moment): boolean {
    return this.selectedDatesUsu.filter(filtDate => filtDate.idTipus != -1).findIndex(selectedDate => {
      return moment(date).isSame(selectedDate.mDate, 'day');
    }) > -1;
  }

  isSame(date1: moment.Moment, date2: moment.Moment): boolean {
    return moment(date1).isSame(date2);
  }

  isSelectedMonth(date: moment.Moment): boolean {
    return moment(date).isSame(this.currentDate, 'month');
  }

  // actions from calendar
  prevMonth(): void {
    this.currentDate = moment(this.currentDate).subtract(1, 'months');
    this.generateCalendar();
  }

  nextMonth(): void {
    this.currentDate = moment(this.currentDate).add(1, 'months');
    this.generateCalendar();
  }

  firstMonth(): void {
    this.currentDate = moment(this.currentDate).startOf('year');
    this.generateCalendar();
  }

  lastMonth(): void {
    this.currentDate = moment(this.currentDate).endOf('year');
    this.generateCalendar();
  }

  prevYear(): void {
    this.currentDate = moment(this.currentDate).subtract(1, 'year');
    this.generateCalendar();
  }

  nextYear(): void {
    this.currentDate = moment(this.currentDate).add(1, 'year');
    this.generateCalendar();
  }

  // generate the calendar grid
  generateCalendar(): void {
    const dates = this.fillDates(this.currentDate);
    let dies = [];
    const weeks: CalendarDate[][] = [];

    this.manageCalendariService.getTipusDies().subscribe(res => { this.tipusDies = res; });
    this.manageCalendariService.getTotalsTipusDies(this.usuari,this.currentDate.format('YYYY')).subscribe(res => { this.totalsDies = res;});

    Object.assign(dies,dates);
    while (dates.length > 0)weeks.push(dates.splice(0, 7));
    this.weeks = weeks;
    //Calendari de l'usuari
    this.manageCalendariService.getCalendari(this.usuari, this.currentDate.locale('ca').format('M')+"-"+this.currentDate.format('YYYY'))
    .subscribe(userCal => {
      userCal.map(item =>  this.selectedDatesUsu.push({mDate: moment( new Date(item.any, item.mes-1, item.dia)), idTipus: item.idtipus, today: null, observacions: item.observacions}));
      //Calendari de global
      this.manageCalendariService.getCalendari(null, this.currentDate.locale('ca').format('M')+"-"+this.currentDate.format('YYYY'))
      .subscribe(admCal => {
        admCal.map(item =>  this.selectedDatesAdm.push({mDate: moment( new Date(item.any, item.mes-1, item.dia)), idTipus: item.idtipus, today: null, observacions: item.observacions}));
     });
    });
  }

  fillDates(currentMoment: moment.Moment): CalendarDate[] {
    const firstOfMonth = moment(currentMoment).startOf('month').isoWeekday(this.iniciDilluns).day();
    const firstDayOfGrid = moment(currentMoment).startOf('month').isoWeekday(this.iniciDilluns).subtract(firstOfMonth, 'days');
    const start = firstDayOfGrid.date()+(this.locale == 'ca'?1:0);
  
    _.range(start, start + 42).map((item, index) => {
      this.colorFons[index]=((index%7 == 6 || index%7 == 0)?this.weekEndBkColor:this.bkColor);
      this.colorText[index]=((index%7 == 6 || index%7 == 0)?this.weekEndTxColor:this.txColor);
    });
    return _.range(start, start + 42)
      .map((date: number, index: number): CalendarDate => {
        const d = moment(firstDayOfGrid).date(date);
        return {
          today: this.isToday(d),
          idTipus: null,
          mDate: d
        };
      });
  }

  onMouseClick(ev, date, item) {
    this.pos = this.selectedDatesUsu.findIndex(item => {return moment(item.mDate).isSame(date)});

    if(this.pos != -1){
      if(this.selectedDatesUsu[this.pos].idTipus == -1)//Reselecciona dia
        this.selectedDatesUsu[this.pos].idTipus = this.tipusIncidencia;
      //Deselecciona dia
      else {this.selectedDatesUsu[this.pos].idTipus = -1;this.pos = -1;return}
    }
    //Selecciona o reselecciona un deseleccionat
    this.observacions = this.incidenciaSelectedUsuObs(date);
    this.display = date;
   }

  desarObs(event): void {//Selecciona dia al tancar dialeg (div) entrada d'observacions
    event.stopPropagation();event.preventDefault();
    if(this.pos != -1)this.selectedDatesUsu.splice(this.pos,1);
    this.selectedDatesUsu.push({mDate: this.display, observacions: this.observacions, idTipus: this.tipusIncidencia, today: null});
    this.display = null;this.pos = -1;
  }

  tancarObs(event): void {
    event.stopPropagation();event.preventDefault();
    this.display = null;this.pos = -1;
    this.observacions = "";
  }

  desar(): void {
    this.manageCalendariService.saveCalendari(this.usuari, this.selectedDatesUsu).subscribe(res => {});
    this.observacions = "";this.display = null;
  }

  tancar(){
    this.dialogRef.close();
  }
}
